import { isOrderModalShown } from './order.cache';

export const order = {
  read() {
    return {
      isOrderModalShown: isOrderModalShown(),
    };
  },
};
